module.exports = __webpack_public_path__ + "img/eye-dropper.56a402a2.svg";